import { render, staticRenderFns } from "./ActivityTabHistory2.vue?vue&type=template&id=3ef99478&scoped=true&"
import script from "./ActivityTabHistory2.vue?vue&type=script&lang=js&"
export * from "./ActivityTabHistory2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef99478",
  null
  
)

export default component.exports